import { render, staticRenderFns } from "./NotificationLoader.vue?vue&type=template&id=67dabcc8&"
import script from "./NotificationLoader.vue?vue&type=script&lang=js&"
export * from "./NotificationLoader.vue?vue&type=script&lang=js&"
import style0 from "./NotificationLoader.vue?vue&type=style&index=0&id=67dabcc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports